import { useState } from "react";
import { useAuth } from "utils/auth";

import styles from "./NonMeteredNudge.module.scss";
import CloseIcon from "assets/x.svg";

type Category = {
  slug?: string;
};

const NonMeteredNudge = ({ categories }: { categories?: Array<Category> }) => {
  const { hasPaywallAccess } = useAuth();
  const [showNudge, setShowNudge] = useState(!hasPaywallAccess);

  // Determine whether to show the coronavirus copy or the default copy,
  // based on whether or not the article is assigned to the "coronavirus-covid-19" category
  const isCorona = categories?.some(
    (category) => category.slug == "coronavirus-covid-19"
  );

  const defaultNudgeCopy = {
    desktopText:
      "Enjoy unlimited access to The Atlantic for less than $1 per week.",
    mobileText: "Subscribe for less than $1 per week",
    subscribeText: "Subscribe Now",
  };
  const coronaNudgeCopy = {
    desktopText:
      "You’re reading The Atlantic’s free coronavirus coverage. To support this vital reporting, subscribe today.",
    mobileText: "Subscribe to support our reporting",
    subscribeText: "See Plans",
  };

  const nudgeCopy = isCorona ? coronaNudgeCopy : defaultNudgeCopy;

  if (!showNudge) return null;

  return (
    <aside
      className={styles.root}
      data-testid="non-metered-nudge"
      data-category="nudge interaction"
      data-label="non-metered nudge"
    >
      <div className={styles.container}>
        <a
          className={styles.textContainer}
          href="https://accounts.theatlantic.com/products/?source=nonmetered_nudge"
          data-action="nudge:click"
        >
          <div className={styles.desktopTextContainer}>
            <p id="nudge-text" className={styles.desktopText}>
              {nudgeCopy.desktopText}
            </p>
            <p className={styles.subscribe}>{nudgeCopy.subscribeText}</p>
          </div>
          <p className={styles.mobileText}>{nudgeCopy.mobileText} </p>
        </a>
        <button
          className={styles.closeButton}
          onClick={() => setShowNudge(false)}
          aria-label="Close Nudge"
          data-action="nudge:user_close"
        >
          <CloseIcon title="Close" className={styles.icon} />
        </button>
      </div>
    </aside>
  );
};

export default NonMeteredNudge;
